import React from "react"
import {useTranslation} from "react-i18next"
import {ArrowPathIcon} from "@heroicons/react/20/solid"

import {Link} from "../../../../components/Link.tsx"
import {AdvancedLeadsContext} from "./context/context.ts"

export const AdvancedSearchReset: React.FC = () => {
  const {t} = useTranslation()
  const advancedSearch = AdvancedLeadsContext.useOptionalContext()

  const handleResetClick = React.useCallback(() => {
    advancedSearch?.setPrompt.call(null, "reset")
  }, [advancedSearch?.setPrompt])

  return (
    <Link
      onClick={handleResetClick}
      disabled={advancedSearch?.stage === "filtering"}
      className={"flex items-center gap-2"}
      variant={"black"}
      flipUnderline
    >
      <ArrowPathIcon className={"size-5 shrink-0"} />
      {t("Prospects_ImportModal_LeadsStep_Advanced_Reset")}
    </Link>
  )
}
